// extracted by mini-css-extract-plugin
export var dlc_header = "dlcHeader-module--dlc_header--305bf";
export var dlc_header_wrapper = "dlcHeader-module--dlc_header_wrapper--60cb2";
export var header_text = "dlcHeader-module--header_text--f0b99";
export var header_wrapper = "dlcHeader-module--header_wrapper--2b967";
export var omni_search = "dlcHeader-module--omni_search--6e368";
export var omni_search_wrapper = "dlcHeader-module--omni_search_wrapper--bff9d";